(() => {
  function init(root) {
    if (!root || root.dataset.enhanced) return;
    root.dataset.enhanced = 'true';
    const lines = ['sport','professional','arborist'];
    const links = [...root.querySelectorAll('[data-ab-line]')];
    const cards = [...root.querySelectorAll('[data-ab-card]')];
    const navs = [...root.querySelectorAll('[data-ab-subtabs]')];
    const tabs = [...root.querySelectorAll('[data-ab-category-link]')];
    const labels = JSON.parse(root.querySelector('[data-ab-tab-labels]').textContent);
    let line = 'professional', category = 'ropes';
    function render() {
      const available = tabs.filter(t => t.dataset.abCategoryLine === line);
      if (!available.some(t => t.dataset.abCategoryLink === category)) {
        category = available.some(t => t.dataset.abCategoryLink === 'ropes') ? 'ropes' : available[0]?.dataset.abCategoryLink;
      }
      const current = available.find(t => t.dataset.abCategoryLink === category);
      let count = 0;
      cards.forEach(c => {
        c.hidden = c.dataset[line] !== category;
        if (!c.hidden) count++;
      });
      links.forEach(a => {
        if (a.dataset.abLine === line) a.setAttribute('aria-current','true');
        else a.removeAttribute('aria-current');
      });
      navs.forEach(nav => {nav.hidden = nav.dataset.abSubtabs !== line;});
      tabs.forEach(a => {
        if (a === current) a.setAttribute('aria-current','true');
        else a.removeAttribute('aria-current');
      });
      root.querySelector('.rh-ab-empty').hidden = count !== 0;
      root.querySelector('[data-ab-selection]').textContent = `${labels[line]} / ${current?.dataset.abCategoryLabel || labels.ropes}`;
      root.querySelector('[data-ab-result]').textContent = `${count} ${labels.listings}`;
    }
    function fromHash(scroll) {
      const match = location.hash.match(/^#armbury-(sport|professional|arborist)(?:--([a-z-]+))?$/);
      if (match) {
        line = match[1]; category = match[2] || 'ropes'; render();
        if (scroll) requestAnimationFrame(() => root.querySelector('.rh-ab-discover').scrollIntoView({block:'start'}));
      }
    }
    const select = (nextLine,nextCategory) => {
      line = nextLine; category = nextCategory;
      history.pushState(null,'',`#armbury-${line}--${category}`);
      render();
    };
    root.querySelector('[data-ab-controls]').hidden = false;
    links.forEach(a => a.addEventListener('click',e => {e.preventDefault();select(a.dataset.abLine,'ropes');}));
    tabs.forEach(a => a.addEventListener('click',e => {e.preventDefault();select(a.dataset.abCategoryLine,a.dataset.abCategoryLink);}));
    window.addEventListener('hashchange',()=>fromHash(true));
    window.addEventListener('popstate',()=>fromHash(false));
    root.addEventListener('shopify:block:select',e => {
      const card = e.target.closest('[data-ab-card]');
      if (card) {
        line = lines.find(l => card.dataset[l] && card.dataset[l] !== 'none') || 'professional';
        category = card.dataset[line];render();
      }
    });
    render();fromHash(true);
  }
  const scan = () => document.querySelectorAll('[data-rh-armbury]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan);
  else scan();
  if (!window.rhArmburyEditorBound) {
    document.addEventListener('shopify:section:load',scan);
    window.rhArmburyEditorBound = true;
  }
})();
